<template>
  <div class="single">
    <APost :post="post" :single="single"/>

    <router-link to="/" class="button">Back Home</router-link>
  </div>
</template>

<script>
// butter CMS
import Butter from "buttercms";
const butter = Butter("45cafa75f025d3699ac7a4fec5ef3850db278cc7");

// components
import APost from "@/components/APost";

export default {
  name: "Single",
  data() {
    return {
      post: [],
      single: true
    };
  },
  components: {
    APost
  },
  methods: {
    getPost() {
      butter.post
        .retrieve(this.$route.params.slug)
        .then(resp => {
          this.post = resp.data.data;
        })
        .catch(resp => {
          console.log(resp);
        });
    }
  },
  created() {
    this.getPost();
  },
  metaInfo() {
    return {
      title: this.post.title
    };
  }
};
</script>

<style scoped>
.single {
  max-width: 850px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 100px;
}
</style>
